import React, { useEffect } from "react";
import { ConnectedProps, connect } from "react-redux";
import i18next from "config/i18next";
import * as yup from "yup";
import { actions as loginActions } from "../../reducers/login";
import { actions as sessionActions, sessionSelector } from "reducers/session";

import Login from "./Login";
import { VALIDATION_REGEX } from "utils/constants";
import { LoginContainerType, LoginFormType, LoginType } from "./types";
import { AppDispatch, RootState } from "../../store";
import { CountryCodeType } from "reducers/types/session";
import { DEFAULT_COUNTRY } from "hooks/useSession";

const LoginContainer = (
  props: LoginContainerType & ConnectorProps
): JSX.Element => {
  useEffect(() => {
    props.resetFetching();
    props.resetDirty();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validationSchema: yup.SchemaOf<LoginFormType> = yup.object({
    email: yup
      .string()
      .required(i18next.t("validations:required"))
      .matches(
        VALIDATION_REGEX.regEmail,
        i18next.t("validations:invalidEmailFormat")
      ),
    password: yup.string().required(i18next.t("validations:required")),
  });

  const onSubmit = (values: LoginFormType) => {
    props.postLogin({
      ...values,
      countryCode: props.countryCode || DEFAULT_COUNTRY,
    });
  };

  return (
    <Login
      {...props}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      testId="login"
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  isFetching: sessionSelector(state).fetching,
  countryCode: sessionSelector(state).countryCode,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  postLogin: (params: LoginType) => {
    dispatch(loginActions.getLoginRequest(params));
  },
  updateCountryCode: (countryCode: CountryCodeType) => {
    dispatch(sessionActions.setCountryCode(countryCode));
  },
  resetFetching: () => {
    dispatch(sessionActions.resetFetching());
  },
  resetDirty: () => {
    dispatch(sessionActions.setDirty(false));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(LoginContainer);
